import * as v from 'valibot'
import type { NavbarAppSwitcherMarketingData } from '@/navbar/navbar.types'

// valibot's record() schema accepts arrays (they are plain objects in JS), so
// we pipe through a non-array check first for any field that must be a plain object.
const stringRecord = () =>
  v.pipe(
    v.custom<Record<string, string>>(input => typeof input === 'object' && input !== null && !Array.isArray(input)),
    v.record(v.string(), v.string()),
  )

const TaxonomyNamespaceSchema = v.object({
  identifier: v.string(),
  marketing_urls: stringRecord(),
  products: v.array(v.string()),
  whitespace: v.array(v.string()),
  display_order: v.number(),
  default_show: v.boolean(),
})

const TaxonomyCapabilitySchema = v.object({
  namespace_identifier: v.string(),
  product_identifier: v.string(),
  product_internal_path: v.string(),
  labels: stringRecord(),
  marketing_urls: stringRecord(),
})

const MarketingDataSchema = v.object({
  all_apps_url: v.string(),
  explore_more_urls: stringRecord(),
  header_text: stringRecord(),
  body_text: stringRecord(),
  namespaces: v.array(TaxonomyNamespaceSchema),
  capabilities: v.array(TaxonomyCapabilitySchema),
})

export function parseMarketingData(json: unknown): NavbarAppSwitcherMarketingData {
  return v.parse(MarketingDataSchema, json)
}
